export const APP_CONFIG = {
  brand: {
    name: "羊必火",
    englishName: "YANG BI HUO",
    shortName: "YBH",
  },
  token: {
    contract: "0xc839b8f4f6ded0cae5531a603b78ede6ca677777",
    name: "羊必火",
    symbol: "羊必火",
    decimals: 18,
    chain: "BNB Chain",
    chainId: "bsc",
    pairAddress: "0x835F8441bE2e2B088Da9b590a9Efb4AD222Ace72",
    pairName: "羊必火 / WBNB",
    dex: "PancakeSwap V2",
    explorer: "https://bscscan.com/token/0xc839b8f4f6ded0cae5531a603b78ede6ca677777",
    pairExplorer: "https://bscscan.com/address/0x835F8441bE2e2B088Da9b590a9Efb4AD222Ace72",
    dexScreener: "https://dexscreener.com/bsc/0x835f8441be2e2b088da9b590a9efb4ad222ace72",
    geckoTerminal: "https://www.geckoterminal.com/bsc/pools/0x835f8441be2e2b088da9b590a9efb4ad222ace72",
  },
  api: {
    tokenMarket: "https://api.dexscreener.com/latest/dex/search?q=",
    tokenOhlcv: "https://api.geckoterminal.com/api/v2/networks/bsc/pools/",
    mainstreamMarket: "https://api.coingecko.com/api/v3/simple/price",
    marketRefreshMs: 20_000,
    tickerRefreshMs: 30_000,
    requestTimeoutMs: 10_000,
  },
  countdownTarget: "2027-02-06T00:00:00+08:00",
  socials: {
    x: "",
    telegram: "",
    community: "",
  },
  images: {
    hero: { path: "/assets/optimized/scene-01.webp", original: "/assets/original/scene-01.png", desktop: "48% 48%", mobile: "42% 52%" },
    trend: { path: "/assets/optimized/scene-02.webp", original: "/assets/original/scene-02.png", desktop: "48% 48%", mobile: "57% 52%" },
    market: { path: "/assets/optimized/scene-03.webp", original: "/assets/original/scene-03.png", desktop: "54% 44%", mobile: "52% 38%" },
    year2027: { path: "/assets/optimized/scene-04.webp", original: "/assets/original/scene-04.png", desktop: "54% 50%", mobile: "48% 50%" },
    story: { path: "/assets/optimized/scene-05.webp", original: "/assets/original/scene-05.png", desktop: "42% 52%", mobile: "41% 48%" },
    culture: { path: "/assets/optimized/scene-06.webp", original: "/assets/original/scene-06.png", desktop: "51% 46%", mobile: "54% 50%" },
    community: { path: "/assets/optimized/scene-07.webp", original: "/assets/original/scene-07.png", desktop: "48% 52%", mobile: "50% 52%" },
    ending: { path: "/assets/optimized/scene-08.webp", original: "/assets/original/scene-08.png", desktop: "50% 42%", mobile: "50% 34%" },
    meme09: { path: "/assets/optimized/meme-09.webp", original: "/assets/original/meme-09.png", desktop: "50% 45%", mobile: "50% 46%" },
    meme10: { path: "/assets/optimized/meme-10.webp", original: "/assets/original/meme-10.png", desktop: "50% 44%", mobile: "50% 43%" },
    avatar: { path: "/assets/optimized/avatar-11.webp", original: "/assets/original/avatar-11.png", desktop: "50% 50%", mobile: "50% 50%" },
  },
  theme: {
    dark: "#11110f",
    light: "#e8e8e4",
    accent: "#d8b36a",
  },
} as const;

export const MARKET_SYMBOLS = [
  { id: "bitcoin", symbol: "BTC", pair: "BTCUSDT" },
  { id: "ethereum", symbol: "ETH", pair: "ETHUSDT" },
  { id: "binancecoin", symbol: "BNB", pair: "BNBUSDT" },
  { id: "solana", symbol: "SOL", pair: "SOLUSDT" },
  { id: "dogecoin", symbol: "DOGE", pair: "DOGEUSDT" },
  { id: "shiba-inu", symbol: "SHIB", pair: "SHIBUSDT" },
  { id: "pepe", symbol: "PEPE", pair: "PEPEUSDT" },
  { id: "floki", symbol: "FLOKI", pair: "FLOKIUSDT" },
] as const;

export type ImageKey = keyof typeof APP_CONFIG.images;
